import CryptoJS             from 'crypto-js';
import AES                  from 'crypto-js/aes';
import moment               from 'moment';
import {apiClient, apiList} from './apiClient';
import Validation           from "./validation";

/**
 * Messages define
 */
const messages = {
  errorGet              : '該当するデータが存在しません。',
  errorDuplicateLogin   : '重複したログインが確認されたため、強制的にログアウトされました。同一のログインIDによる二重ログインは、後からのログインを優先します。',
  errorDuplicateWindow  : '一度に複数の画面は開けません、以前の画面を閉じてからご利用ください。',
  errorTokenExpired     : '長時間操作が行われなかったため、自動的にログアウトされました。再度ログインしてください。',
  errorMaintenanceMode  : 'システムがメンテナンス中です。',
  errorOutOfBusinessTime: '※ 利用時間外のため、新規登録・利用再開が行えません。<br/>　 利用時間：平日8:30〜22:55・土日祝日8:30〜17:55',
  errorNotFound         : '該当する情報が見つかりませんでした。',
  errorLimited          : 'トライアル上限回数に達しました。',
  errorTransferRole     : '管理者権限が他のユーザーに譲渡されたため、強制的にログアウトされました。再度ログインしてご利用ください。',
  errorDownload         : 'ダウンロードに失敗しました。',
  serverError           : 'システムエラーが発生しました。再度お試しになるか、問題が続く場合はカスタマーサポートまでご連絡ください。',
  emailConfirm          : {
    successMessage: '確認メールを送信しました。メールをご確認ください。',
  },
  requestTrial          : {
    acceptTermMessage: '利用規約をご確認ください。',
    successMessage   : 'お申し込みありがとうござます。システムのユーザーIDとパスアードを登録いただいたメールアドレスに送信しましたのでご確認ください。',
  },
  informationList       : {
    confirmTitle    : '削除の確認',
    confirmContent  : 'お知らせを削除します。よろしいですか？',
    successDeleteMsg: 'お知らせを削除しました。',
  },
  informationEdit       : {
    notFound       : '該当する情報が見つかりませんでした。',
    registrySuccess: 'お知らせを登録しました。',
    registryError  : 'お知らせの登録に失敗しました。',
    updateSuccess  : 'お知らせを更新しました。',
    updateError    : 'お知らせの更新に失敗しました。',
  },
  faqList               : {
    confirmTitle          : '削除の確認',
    confirmContent        : 'よくある質問を削除します。よろしいですか？',
    confirmCategoryContent: 'カテゴリを削除します。よろしいですか？',
    successDeleteMsg      : 'よくある質問を削除しました。',
    successReorderMsg     : 'よくある質問の順序を更新しました。',
  },
  faqCategoryEdit       : {
    notFound       : '該当する情報が見つかりませんでした。',
    registerSuccess: 'カテゴリを登録しました。',
    registerError  : 'カテゴリの登録に失敗しました。',
    updateSuccess  : 'カテゴリを更新しました。',
    updateError    : 'カテゴリの更新に失敗しました。',
  },
  faqEdit               : {
    notFound       : '該当する情報が見つかりませんでした。',
    registerSuccess: 'よくある質問を登録しました。',
    registerError  : 'よくある質問の登録に失敗しました。',
    updateSuccess  : 'よくある質問を更新しました。',
    updateError    : 'よくある質問の更新に失敗しました。',
  },
  paymentMethod         : {
    deleteSuccess: '支払方法を削除しました。',
    notFound     : '該当する情報が見つかりませんでした。',
    insertSuccess: '支払方法を登録しました。',
    insertError  : '支払方法の登録に失敗しました。',
    updateSuccess: '支払方法を更新しました。',
    updateError  : '支払方法の更新に失敗しました。',
    cardNotValid : 'クレジットカード情報をご確認ください。',
    authFailed   : '本人認証に失敗しました。再度お試しいただくか、別のカードもしくは銀行振込をご利用ください。',
    authError    : '本人認証処理中にエラーが発生しました。時間をおいて再度お試しください。',
  },
  paymentSetting        : {
    updatePlanSuccess   : 'プランを変更しました。',
    updatePlanError     : 'プランの変更に失敗しました。',
    updatePaymentSuccess: '支払情報を変更しました。',
    updatePaymentError  : '支払情報の変更に失敗ました。',
    nameDefault         : 'デフォルト',
  },
  manager               : {
    deleteSuccess  : 'システム管理者を削除しました。',
    notFound       : '該当する情報が見つかりませんでした。',
    registrySuccess: 'システム管理者を登録しました。',
    registryError  : 'システム管理者の登録に失敗しました。',
    updateSuccess  : 'システム管理者を更新しました。',
    updateError    : 'システム管理者の更新に失敗しました。',
  },
  group                 : {
    deleteSuccess  : '部門を削除しました。',
    notFound       : '該当する情報が見つかりませんでした。',
    registrySuccess: '部門を登録しました',
    registryError  : '部門の登録に失敗しました。',
    updateSuccess  : '部門を更新しました。',
    updateError    : '部門の更新に失敗しました。',
  },
  account               : {
    updatePasswordSuccess: 'パスワードを更新しました。',
    updatePasswordError  : 'パスワードの更新に失敗しました。',
    deleteSuccess        : 'ユーザーを削除しました。',
    deregisterSuccess    : 'ユーザーを利用解除しました。',
    registerSuccess      : 'ユーザーを利用登録しました。',
    resumeSuccess        : 'ユーザーを利用再開しました。',
    notFound             : '該当する情報が見つかりませんでした。',
    registrySuccess      : 'ユーザーを登録しました。',
    registryError        : 'ユーザーの登録に失敗しました。',
    updateSuccess        : 'ユーザーを更新しました。',
    updateError          : 'ユーザーの更新に失敗しました',
    authFailed           : 'ログインできませんでした。ログインID・パスワードをご確認ください。',
    tokenNotValid        : '選択されたトークンは、有効ではありません。',
  },
  terminate             : {
    terminateSuccess: '退会の申請を受け付けました。当月末まではサービスをご利用いただけます。',
    terminateError  : '退会の処理に失敗しました。時間をおいて再度試していただくか、お問い合わせフォームよりお問い合わせください。',
  },
  map_imaging_limited   : '同時に表示可能な上限に達しました。',
  activation            : {
    success    : '登記情報提供サービスのアカウント紐付けに成功しました。',
    error      : '登記情報提供サービスのアカウント紐付けに失敗しました。認証サーバーが混み合っているか営業時間外のため、認証できませんした。時間をおいて再度お試しください。',
    unactivated: '認証を行ってください。',
    reActivated: '登記情報提供サービスが解除されています。再度を認証を行ってください。',
  },
  registration          : {
    success                   : '登記情報の取得を開始しました。',
    error                     : '登記情報の取得に失敗しました。',
    retry                     : {
      success: '登記情報の取得を開始しました。',
      error  : '登記情報の取得に失敗しました。',
    },
    not_available             : '利用時間外のため、情報の取得ができません。',
    not_available_map_and_draw: 'ただいまの時間は地図情報及び図面情報に関するサービス利用時間外です。',
    duplicated                : '同一条件の登記情報の取得中です、取得を中止しました。',
    messages                  : {
      not_available: 'ただいまの時間は地図情報及び図面情報に関するサービス利用時間外です',
    }
  },
  reachMaximumRetry     : '認証サーバーが混み合っているか営業時間外のため、認証できませんした。時間をおいて再度お試しください。',
  billings              : {
    downloadError: 'ダウンロードに失敗しました。',
    emailControl: {
      getError      : 'メール自動送信の状態を取得できませんでした。',
      holdSuccess   : 'メール自動送信を停止しました。',
      holdError     : 'メール自動送信を停止できませんでした。',
      releaseSuccess: 'メール自動送信の停止を解除しました。',
      releaseError  : 'メール自動送信の停止を解除できませんでした。',
      unknownStatus : 'メール自動送信の状態を確認できませんでした。',
    },
  },
  map                   : {
    geocodingNotFound     : '該当する所在が見つかりませんでした。',
    routeMapNotFound      : '路線価図が見つかりませんでした。',
    notAvailableZoomLevel : 'JON地番地図が表示できないズームレベルです。',
    rightClickGeoLayer    : 'JON地番地図が表示できないエリアです。',
    notZoomLevel100       : 'ブラウザのズームレベルを100％でご利用ください。',
    lotNumberNotFound     : '地番確認が見つかりませんでした。',
    jonSearchNotFound     : '市区町村の指定が必要です。',
    requiredAddress       : '住所必ず指定してください。',
    buildingNumberNotFound: '該当する家屋番号が見つかりませんでした。',
    requiredMultiPoint    : '地点を選択してください。',
    requiredMovingPoint   : '地点を選択してください。',
    requiredDestination   : '移動先を選択してください。',
  },
  measureMarkerTitle    : 'ドラッグ可能、クリックして削除します。',
  movingMarkerTitle     : 'ドラッグ可能、クリックして削除します。',
  history               : {
    downloadError: 'ダウンロードに失敗しました。',
  },
  pdf                   : {
    creatingZipFile: 'zipファイルの作成',
    downloadError  : 'ダウンロードに失敗しました。',
    limitError     : '選択できるのは:limit件までです',
    limitModalError: '一括でダウンロードできる件数を超えています。取得履歴からダウンロードしてください',
  },
  movingMyPoint         : {
    success: '登記情報の移動しました。',
    failure: '登記情報の移動に失敗しました。',
  },
  contract              : {
    codeInvalid: '認証コードが、有効な形式ではありません。',
  },
  apply                 : {
    failure: '利用規約へ同意する',
  },
  notification         : {
    notFound: '現在お知らせはありません。',
  }
};

/**
 * List of cities
 */
const prefectures = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県"
];

const contractReason = [
  'JON(営業担当)からのご案内',
  'インターネット検索・広告',
  '業界紙、ニュース記事',
  '口コミ(ご紹介)',
  '展示会等のイベント',
  'その他',
];

const contractReasonForSales = [
  'JON(営業担当)からのご案内',
  'インターネット検索・広告',
  '業界紙、ニュース記事',
  '口コミ(ご紹介)',
  '展示会等のイベント',
  'その他',
];

/**
 * All local storage keys
 */
const localStorageKeys = {
  redirectToUser : 'redirectToUser',
  redirectToAdmin: 'redirectToAdmin',
  numberAccount  : 'numberAccount',
  requestSuccess : 'RequestSuccess',
  user           : {
    accessToken               : 'userAccessToken',
    accessTokenExpireIn       : 'userAccessTokenExpireIn',
    tServiceTrial             : 'userTServiceTrial',
    tServicePassword          : 'userTServicePassword',
    auth                      : 'authAccount',
    errorForceLogin           : 'userErrorForceLogin',
    errorTransferRole         : 'userErrorTransferRole',
    sendPasswordAccountCreated: 'userSendPasswordAccountCreated',
    redirectAfterMaintenance  : 'redirectAfterMaintenance',
    fromLogin                 : 'fromLogin',
  },
  admin          : {
    accessToken             : 'adminAccessToken',
    accessTokenExpireIn     : 'adminAccessTokenExpireIn',
    errorForceLogin         : 'adminErrorForceLogin',
    redirectAfterMaintenance: 'adminRedirectAfterMaintenance',
  },
  snackBarMessage: 'snackBarMessage',
  map            : {
    hideNotifications: 'map.hideNotifications',
  },
  contract       : {
    verify: 'contract.verify',
    email : 'contract.email',
  },
  paymentNew     : {
    verify: 'paymentNew.verify',
  },
};

/**
 * Google values
 */
const google = {
  statusOk: 'OK',
};

/**
 * Billing method
 */
const billingMethods = {
  1: 'クレジットカード',
  2: '銀⾏振込',
  // TODO 3: 口座振替による支払い（フェーズ1未実装）
};

/**
 * Billing via
 */
const billingVia = {
  0: 'メール',
  1: '郵送',
};

/**
 * Billing via with fee
 */
const billingViaWithFee = {
  0: 'メール',
  1: '郵送(300円)/月',
};

/**
 * Limit billing month search
 */
const limitBillingMonth = 13;

/**
 * Limit billing month minimum
 */
const minBillingMonth = process.env.VUE_APP_MIN_BILLING_MONTH ? process.env.VUE_APP_MIN_BILLING_MONTH : '2020-07';

/**
 * Registration limit page [map sidebar]
 * @type {number}
 */
const registrationLimitPage = 1000;

const momentConst = {
  timeZone           : 'Asia/Tokyo',
  dateFormatShort    : 'YYYYMMDD',
  dateFormat         : 'YYYY-MM-DD',
  dateFormatYearMonth: 'YYYYMM',
  dateFormatPdf      : 'YYYY-MM',
  dateTimeFormat     : 'YYYY-MM-DD HH:mm:ss',
  dateTimeTFormat    : 'YYYY-MM-DDTHH:mm:ss',
  startDateFormat    : 'YYYY-MM-DD 00:00:00',
  endDateFormat      : 'YYYY-MM-DD 23:59:59',
  startDateTFormat   : 'YYYY-MM-DDT00:00:00',
  endDateTFormat     : 'YYYY-MM-DDT23:59:59',
  timeFormat         : 'HH:mm:ss',
  sundayName         : '日曜日',
  saturdayName       : '土曜日',
  japaneseDateFormat : 'YYYY年M月D日',
  suffixFormat       : 'YYYYMMDDHHmmss',
};

/**
 * 全部事項
 */
const pdfTypeWholeData = 1;

/**
 * 所有者事項
 */
const pdfTypeOwnerData = 2;

/**
 * 公図
 */
const pdfTypeMap = 3;

/**
 * 土地所在図/地積測量図
 */
const pdfTypeLandSurveyMap = 4;

/**
 * 地役権図面
 */
const pdfTypeEasementDrawing = 5;

/**
 * 建物図面/各階平面図
 */
const pdfTypeBuildingDrawing = 6;

const pdfTypes = [
  {code: pdfTypeWholeData, name: '全部事項'},
  {code: pdfTypeOwnerData, name: '所有者事項'},
  {code: pdfTypeMap, name: '地図(公図)'},
  {code: pdfTypeLandSurveyMap, name: '地積測量図'},
  {code: pdfTypeEasementDrawing, name: '地役権図面'},
  {code: pdfTypeBuildingDrawing, name: '建物図面'},
];

const parcelPdfTypes = [
  pdfTypeWholeData,
  pdfTypeOwnerData,
  pdfTypeMap,
  pdfTypeLandSurveyMap,
  pdfTypeEasementDrawing,
];

const buildingPdfTypes = [
  pdfTypeWholeData,
  pdfTypeOwnerData,
  pdfTypeBuildingDrawing,
];

const specialPdfTypes = [
  {code: 10, name: 'JON地番地図'},
  {code: 11, name: '路線価図'},
  {code: 12, name: 'ログイン'},
  {code: 13, name: 'マップ '},
  {code: 14, name: 'ジオコーディング'},
  {code: 15, name: '地番検索'},
];

const specialPdfTypesForUser = [
  {code: 12, name: 'ログイン'},
  {code: 10, name: 'JON地番地図'},
  {code: 11, name: '路線価図'},
  {code: 15, name: '地番検索'},
];

const historyStatuses = [
  {code: 'unacquired', name: '未取得'},
  {code: '4103_1', name: '取得不可(情報量膨大)'},
  {code: '4102_1', name: '所有者事項取得不可(表題部のみ物件)'},
  {code: '4102_2', name: '所有者事項取得不可(システム制限)'},
  {code: '4101_1', name: '事件処理中'},
  {code: '4102_3', name: '国土調査登記処理中'},
  {code: '4102_4', name: '所有者事項取得不可(所有権なし・全部敷地権)'},
  {code: '4102_5', name: '取得不可(コンピュータ未登録)'},
  {code: '4102_6', name: '取得不可(家屋番号の後に「／敷地番」なし)'},
  {code: 'P700_1', name: '取得不可(地番又は家屋番号誤り)'},
  {code: '4102_7', name: '所有者事項取得不可(システム制限)'},
  {code: '4103_2', name: '取得不可(処理エラー)'},
  {code: '4102_8', name: '換地処分登記処理中'},
  {code: 'error_1', name: '認証エラー'},
];

/**
 * 地番
 */
const numberTypeParcel = 1;

/**
 * 家屋番号
 */
const numberTypeBuilding = 2;

const numberTypes = [
  {code: numberTypeParcel, name: '土地'},
  {code: numberTypeBuilding, name: '建物'},
];

/**
 * 支払状況
 */
const paymentStatuses = [
  {code: 0, name: '未払い'},
  {code: 1, name: '一部支払い'},
  {code: 2, name: '支払い済'},
  {code: 99, name: '請求なし'},
];

/**
 * 支払状況 (admin side)
 */
const paymentStatusesAdmin = [
  {code: 0, name: '未入金'},
  {code: 1, name: '一部入金'},
  {code: 2, name: '入金済み'},
  {code: 99, name: '請求なし'},
];

/**
 * logs type
 */
const typeLogs = {
  1 : 'JON地番地図',
  2 : '路線価図',
  3 : 'ログイン',
  4 : 'マップ',
  5 : 'ジオコーディング',
  6 : '地番検索',
  7 : '全部事項',
  8 : '所有者事項',
  9 : '地図(公図)',
  10: '地積測量図',
  11: '地役権図面',
  12: '建物図面',
};

/**
 * logs registrations
 */
const registrationLogs = {
  7 : '全部事項',
  8 : '所有者事項',
  9 : '地図(公図)',
  10: '地積測量図',
  11: '地役権図面',
  12: '建物図面',
};

/**
 * Plan text
 */
const plans = {
  0: 'トライアルプラン',
  1: '月額プラン',
};

/**
 * Location search types
 */
const locationSearchTypes = {
  google: {
    code: 'google',
    name: '住所検索',
  },
  jon   : {
    code: 'jon',
    name: '地番検索',
  },
};

/**
 * 位置特定レベル
 */
const locatingLevels = [
  {'level': 2, 'error': '一番近い親番付近で特定しました。'},
  {'level': 3, 'error': '丁目字付近で特定しました。'},
  {'level': 4, 'error': '町名大字付近で特定しました。'},
  {'level': 5, 'error': '市区町村付近で特定しました。'},
  {'level': 6, 'error': '都道府県付近で特定しました。'},
];

/**
 * Type user key
 */
const normalUserKey = 'shikakumap_user';
const groupAdminKey = 'shikakumap_group_admin';
const superUserKey  = 'shikakumap_super_user';

/**
 * Order of roles
 *
 * @type {(string)[]}
 */
const roleOrdered = [
  superUserKey,
  groupAdminKey,
  normalUserKey,
]

/**
 * QRコード
 */
const QRCode = {
  Unwanted: {
    code: 0,
    name: '不要',
  },
  Wanted  : {
    code: 1,
    name: '要',
  },
};

/**
 * 共同担保目録
 */
const JointSecurityInventory = {
  Unwanted           : {
    code: 0,
    name: '不要',
  },
  Wanted             : {
    code: 1,
    name: '要',
  },
  WantedPresentMatter: {
    code: 2,
    name: '要(現在事項)',
  },
};

/**
 * 信託目録
 */
const TrustInventory = {
  Unwanted              : {
    code: 0,
    name: '不要',
  },
  Wanted                : {
    code: 1,
    name: '要',
  },
  WantedPresentInventory: {
    code: 2,
    name: '要(現在目録)',
  },
};

/**
 * 営業担当者識別コード
 * @type {string[]}
 */
const sales = [
  '328c9fa7-319b-4417-9b26-c7ef797742d2',
];

/**
 * 家屋番号を表示APIタイムアウト（ms）
 */
const buildingNumbersTimeout = 1200000;


const Common = {
  trialStatus            : 0,
  monthlyStatus          : 1,
  trialEndedStatus       : 99,
  messages               : messages,
  localStorageKeys       : localStorageKeys,
  google                 : google,
  limitBillingMonth      : limitBillingMonth,
  minBillingMonth        : minBillingMonth,
  billingMethods         : billingMethods,
  billingVia             : billingVia,
  billingViaWithFee      : billingViaWithFee,
  registrationLimitPage  : registrationLimitPage,
  prefectures            : prefectures,
  contractReason         : contractReason,
  contractReasonForSales : contractReasonForSales,
  momentConst            : momentConst,
  pdfTypeWholeData       : pdfTypeWholeData,
  pdfTypeOwnerData       : pdfTypeOwnerData,
  pdfTypeMap             : pdfTypeMap,
  pdfTypeLandSurveyMap   : pdfTypeLandSurveyMap,
  pdfTypeEasementDrawing : pdfTypeEasementDrawing,
  pdfTypeBuildingDrawing : pdfTypeBuildingDrawing,
  pdfTypes               : pdfTypes,
  specialPdfTypes        : specialPdfTypes,
  specialPdfTypesForUser : specialPdfTypesForUser,
  historyStatuses        : historyStatuses,
  numberTypeParcel       : numberTypeParcel,
  numberTypeBuilding     : numberTypeBuilding,
  numberTypes            : numberTypes,
  typeLogs               : typeLogs,
  registrationLogs       : registrationLogs,
  buildingNumbersTimeout : buildingNumbersTimeout,
  loginLogType           : '3',
  googleSearchLogType    : '5',
  jonSearchLogType       : '6',
  billingMethodCreditCard  : '1',
  billingMethodBankTransfer: '2',
  billingViaEmail          : '0',
  allMonths              : ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
  limitPageDefault       : 50,
  // Map
  mapChibanImagingLimit: 6,
  mapRosenImagingLimit : 1,
  plans                : plans,
  // Check activation interval (milliseconds)
  checkActivationInterval: 2000,
  checkRegisterInterval  : 2000,
  maximumActivationRetry : 60,
  paymentStatuses        : paymentStatuses,
  paymentStatusesAdmin   : paymentStatusesAdmin,
  roleSuperUser          : 1,
  roleNormalUser         : 2,
  roleGroupAdmin         : 3,
  acquiredStatus         : 1,
  unAcquiredStatus       : 0,
  incidentErrorCode      : '4101',
  parcelPdfTypes         : parcelPdfTypes,
  buildingPdfTypes       : buildingPdfTypes,
  snackbarAutoCloseTime  : 5000,
  normalUserKey          : normalUserKey,
  groupAdminKey          : groupAdminKey,
  superUserKey           : superUserKey,
  locationSearchTypes    : locationSearchTypes,
  secretKey              : process.env.VUE_APP_CRYPTO_SECRET_KEY ? process.env.VUE_APP_CRYPTO_SECRET_KEY : 'crypto-secret-key',
  locatingLevels         : locatingLevels,
  QRCode                 : QRCode,
  JointSecurityInventory : JointSecurityInventory,
  TrustInventory         : TrustInventory,
  setTimeoutInterval     : 200,
  limitMultiPoint        : 6,
  downloadPdfLimit       : 50, // PDFダウンロード最大件数
  downloadPdfLimitModal  : 50,
  defaultUnFinishCount   : 999,
  sales                  : sales,
  roleOrdered            : roleOrdered,
  /**
   * Calculate simulation price
   *
   * @param prices
   * @param numberOfAccount
   * @return number
   */
  priceCalculator: function (prices, numberOfAccount) {
    let price = 0;

    for (let number = 1; number <= numberOfAccount; number++) {
      for (let priceIndex = prices.length - 1; priceIndex >= 0; priceIndex--) {
        if (number >= prices[priceIndex].account) {
          price += prices[priceIndex].amount - prices[priceIndex].discount;
          break;
        }
      }
    }
    return price;
  },
  /**
   * Calculate unit pirce
   *
   * @param price
   * @param numberOfAccount
   */
  unitPriceCalculator: function (price, numberOfAccount) {
    return Math.floor(price / numberOfAccount);
  },
  /**
   * Calculate consumption tax
   *
   * @param unitPrice
   * @param numberOfAccount
   * @param taxRate when taxRate is 0, it means tax exclusion
   * @returns {*}
   */
  consumptionTaxCalculator: function (unitPrice, numberOfAccount, taxRate = 0) {
    const price = unitPrice * numberOfAccount;
    return price + Math.floor(price * taxRate);
  },
  /**
   * Format number
   * @param number
   * @param decimalPoint null
   * @returns ?string
   */
  numberFormat: function (number, decimalPoint = null) {
    if (_.isNaN(number)) {
      return null;
    }
    const numberFormat = new Intl.NumberFormat();
    if (decimalPoint !== null) {
      return numberFormat.format(number.toFixed(decimalPoint));
    }
    return numberFormat.format(number);
  },
  billingMonthSelectionByLimit(minYearMonth = null) {
    const date        = moment().add(1, 'months');
    let yearMonthList = [];
    for (let i = 0; i < this.limitBillingMonth; i++) {
      let yearMonth = date.format(Common.momentConst.dateFormatYearMonth);
      if (minYearMonth !== null && yearMonth < minYearMonth) {
        break;
      }
      let yearMonthStr = date.format('YYYY') + '年' + date.format('M') + '月';
      yearMonthList.push({
        'key'  : yearMonth,
        'value': yearMonthStr,
      });
      date.subtract(1, 'months')
    }
    return yearMonthList;
  },
  billingMonthSelectionByMinMonth(minMonth) {
    const date        = moment();
    let yearMonthList = [];
    while (true) {
      let yearMonth    = date.format('YYYY') + '' + date.format('MM');
      let yearMonthStr = date.format('YYYY') + '年' + date.format('M') + '月';
      if (date.format(momentConst.dateFormatYearMonth) < moment(minMonth).format(momentConst.dateFormatYearMonth)) {
        break;
      }
      yearMonthList.push({
        'key'  : yearMonth,
        'value': yearMonthStr,
      });
      date.subtract(1, 'months')
    }
    return yearMonthList;
  },
  /**
   * テキスト内のURLをリンク化する
   *
   * @param text
   * @returns {*}
   */
  replaceUrlToLink(text) {
    const pattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;
    return text.replace(pattern, `<a href="$1" target="_blank" rel="noopener">$1</a>`);
  },
  /**
   * Get pdf type name by code
   *
   * @param code
   * @returns {null|*}
   */
  getPdfTypeName: function (code) {
    for (let pdfType of pdfTypes) {
      if (pdfType.code === code) {
        return pdfType.name;
      }
    }
    return null;
  },
  sleep         : function (milliSeconds) {
    return new Promise(resolve => setTimeout(resolve, milliSeconds));
  },
  getCurrentUserInfo() {
    // Check access token
    const accessToken = localStorage.getItem(Common.localStorageKeys.user.accessToken);
    if (accessToken === null) {
      return [];
    }

    // Check auth account
    const authAccountJson = localStorage.getItem(Common.localStorageKeys.user.auth);
    if (authAccountJson === null) {
      return [];
    }

    return JSON.parse(authAccountJson);
  },
  /**
   * Get all roles of current account
   * @return []
   */
  getCurrentUserRoles() {
    // Check auth account has roles
    const authAccount = this.getCurrentUserInfo();
    if (!authAccount.roles) {
      return [];
    }

    // Check list of roles
    if (authAccount.roles.length === 0) {
      return [];
    }

    return authAccount.roles;
  },
  isSuperUser() {
    return this.getCurrentUserRoles().filter(role => role === Common.superUserKey).length > 0;
  },
  isGroupAdmin() {
    return this.getCurrentUserRoles().filter(role => role === Common.groupAdminKey).length > 0;
  },
  isExpiredToken(expiresIn) {
    const expiresInMoment = moment.unix(expiresIn);
    if (!expiresInMoment.isValid()) {
      return false;
    }
    return expiresInMoment.diff(moment()) < 0;
  },
  encrypt(data) {
    if (typeof data === 'undefined' || data === null || data === '') {
      return null;
    }
    return AES.encrypt(data, Common.secretKey).toString();
  },
  decrypt(data) {
    if (typeof data === 'undefined' || data === null || data === '') {
      return null;
    }
    return AES.decrypt(data, Common.secretKey).toString(CryptoJS.enc.Utf8);
  },
  /**
   * 平日8:30〜22:55・土日祝日8:30〜17:50の受付となります。
   *
   * @return Promise<boolean>
   */
  onBusinessTime() {
    return new Promise((resolve, reject) => {
      apiClient
        .get(apiList.jon.confirm_available)
        .then(response => {
          if (response.data && response.data.is_available) {
            resolve(true);
          }
          resolve(false);
        })
        .catch(error => {
          console.error(error);
          resolve(false);
        });
    });
  },
  isNullOrEmpty(data) {
    return (typeof data === 'undefined' || data === null || data === '');
  },
  getLocatingLevelError: function (level) {
    for (let locatingLevel of locatingLevels) {
      if (locatingLevel.level === level) {
        return locatingLevel.error;
      }
    }
    return null;
  },
  /**
   * Get MouseEvent object from map event
   */
  getMouseEvent(event) {
    let mouseEventKey = null;
    mouseEventKey     = Object.keys(event).filter(function (key) {
      if (event[key] && event[key].pageX && event[key].pageY) {
        return true;
      }
    });
    if (mouseEventKey && mouseEventKey.length > 0) {
      return event[mouseEventKey];
    }
    return null;
  },
  /**
   * タッチイベントをサポートしているか
   *
   * @returns {boolean}
   */
  hasTouchSupport() {
    let maxTouchPoints = 0;
    if (typeof navigator.maxTouchPoints !== 'undefined') {
      maxTouchPoints = navigator.maxTouchPoints
    } else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
      maxTouchPoints = navigator.msMaxTouchPoints
    }
    if (maxTouchPoints < 1) {
      return false;
    }

    let touchEvent;
    try {
      document.createEvent('TouchEvent')
      touchEvent = true
    } catch (_) {
      touchEvent = false
    }
    if (touchEvent === false) {
      return false;
    }

    const touchStart = 'ontouchstart' in window
    if (touchStart === false) {
      return false;
    }

    return true;
  },
  /**
   * 全角数字とハイフンを半角に置き換える
   *
   * @param str
   * @returns {*}
   */
  normalizeNumberAndHyphen(str) {
    const half = str.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
    return half.replace(Validation.regex.hyphens, '-');
  },
  /**
   * 都道府県名を都道府県コードに変換する
   * @param prefName
   * @returns {string}
   */
  prefNameToCode(prefName) {
    return String(prefectures.indexOf(prefName) + 1).padStart(2, '0');
  }
};

export default Common;
